<template>
  <v-container class="mt-4  pr-4">
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title>
            <v-spacer></v-spacer>
            <span class="text-subtitle-1">
              <strong>Calendario</strong>
            </span>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>

              <v-col cols="12">
                <v-text-field
                  v-model="fecha"
                  append-outer-icon="mdi-skip-next-circle"
                  prepend-icon="mdi-skip-previous-circle"
                  filled
                  readonly
                  label="Fecha"
                  type="date"
                  @click:append-outer="nextDay"
                  @click:prepend="previousDay"
                ></v-text-field>
              </v-col>
              
              <v-alert
                dense
                outlined
                type="warning"
                v-if="!progra.length"
              >
                No existen clases programadas para este día!
              </v-alert>

              <v-col cols="12" md="6" lg="3" xl="2" v-for="(clase, i ) in progra" :key="i">
                <v-card class="shadowCard">
                  <v-card-text class="px-0">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <div class="text-overline mb-4">
                          <v-chip :color="clase.color" small dark> {{ clase.categoria }} </v-chip>
                        </div>
                        <v-list-item-title class="text-h6 mb-1">
                          {{ clase.hora_inicio.substr(0,5) + ' a ' + clase.hora_fin.substr(0,5) }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-avatar
                        tile
                        size="80"
                        color="transparent"
                      >
                        <v-avatar
                          size="80"
                          color="grey"
                        >
                          <img :src="url + clase.foto" />
                        </v-avatar>
                      </v-list-item-avatar>


                    </v-list-item>

                    <div class="px-4">
                      <strong>{{ clase.nombre_completo }}</strong>
                      <br/>
                      {{ clase.detalles }}
                    </div>

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      v-if="clase.estado_clase == 'Activa'"
                      color="green"
                      tile
                      block
                      dark
                      outlined
                      @click="generarQRCode(clase)"
                    >
                      Activa
                      <v-icon right>mdi-calendar</v-icon>
                    </v-btn>

                    <v-btn 
                      v-if="clase.estado_clase == 'Por iniciar'"
                      color="warning"
                      tile
                      block
                      dark
                      outlined
                      @click="generarQRCode(clase)"
                    >
                      Tomar asistencia
                      <v-icon right>mdi-calendar</v-icon>
                    </v-btn>

                    <v-btn 
                      v-if="clase.estado_clase == 'Vencida'"
                      color="grey"
                      tile
                      block
                      dark
                      outlined
                    >
                      Tomar asistencia
                      <v-icon right>mdi-calendar</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
          ¿Estás seguro de realizar está reservación?
        </v-card-text>

        <v-card-actions>
          <v-btn color="yellow" small tile @click="dialog = false">
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" dark small tile @click="saveReservacion()">
            Sí
            <v-icon small right>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialogQr"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
          <video ref="video" width="100%" height="500" autoplay></video>
        </v-card-text>

        <v-btn small block @click="detectarQR">TOMAR CAPTURA</v-btn>

        <v-btn 
          color="transparent elevation-0"
          x-small
          absolute
          top
          right
          fab
          class="mt-5 mr-0"
          @click="dialogQr = false"
         ><v-icon>mdi-close</v-icon>
        </v-btn>

      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import QRCode from 'qrcode';
  import jsQR from 'jsqr';

  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      defaultItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      // tabla
      paquetes: [],

      libres: 0,
      progra:[],

      url: false,

      clase: null,

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogQr: false,
      qrImagen: null
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioFitHouse']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      fecha(){ this.initialize() }

    },

    beforeDestroy() {
      if (this.$refs.video.srcObject) {
        const stream = this.$refs.video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
      }
    },

    async created () {
      this.url = this.$http.options.root + 'fotos-fithouse/'
      await this.initialize()
    },

    methods: {

      async iniciarCamara() {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true });
          this.$refs.video.srcObject = stream;
        } catch (error) {
          console.error('Error al iniciar la cámara:', error);
        }
      },

      initialize () {
        this.cargar = true
        this.progra = []  

        let payload = {
          dia           : this.fecha,
        }     

        return this.$http.post('programacion.dia.all', payload ).then(response=>{
          this.progra = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      formatoMoneda(monto) {
        const formato = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        });

        return formato.format(monto);
      },

      openView( pago ){
        window.open( pago.url_pago )
      },

      previaReserva ( clase ) {
        if( this.editedItem.cant_clases_restantes > 0  ){
          this.clase = clase
          this.dialog = true
        }else{
          this.validarErrorDirecto('Tu paquete ya no cuenta con clases disponibles, por favor, selecciona otro paquete o realiza la compra de alguno.')
        }
      },

      previousDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() - 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },
      
      nextDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() + 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },

      saveReservacion( ){
        const payload = {
          idpago        : this.editedItem.idpagos,
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
          idprogramacion: this.clase.idprogramacion,
        }

        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('programacion.reservacion', payload).then(response=>{
          this.editedItem.cant_clases_restantes - 1
          this.initialize()
          this.dialog = false
          this.validarSuccess('Para ver tu reservación, ve a tu calendario!')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      async generarQRCode( clase ) {
        try {
          this.dialogQr = true
          this.clase = clase

          console.log( this.clase )

          setTimeout(() => {
            this.detectarQR()
          }, 2000);

          const stream = await navigator.mediaDevices.getUserMedia({ video: true });
          this.$refs.video.srcObject = stream;
        } catch (error) {
          console.error('Error al iniciar la cámara:', error);
        }

      },

      detectarQR() {
        const canvas = document.createElement('canvas');
        const video = this.$refs.video;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const qrCode = jsQR(imageData.data, imageData.width, imageData.height);
        
        if (qrCode) {

          let texto = JSON.parse(qrCode.data)

          this.grabarAsistencia( texto )
          
          // Aquí puedes hacer algo con los datos del código QR, como procesarlos o mostrarlos en la interfaz de usuario
        } else {
          // this.detectarQR()
          requestAnimationFrame(this.detectarQR);
        }
      },


      grabarAsistencia( qrCode ){
        this.dialogQr = false

        let payload = {
          idusuarios      : qrCode.idusuarios,
          idprogramacion  : this.clase.idprogramacion
        }


        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('validar.reservacion', payload).then(response=>{
          this.validarSuccess('Adelante, puedes pasar')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      }

    },
  }
</script>


